import styled from '@emotion/styled';
import { columnGutter, mediaQueries, remCalc } from '../../css';

const StyledArrowPrev = styled('button')(() => ({
    zIndex: 2,
    cursor: 'pointer',
}));

const StyledArrowNext = styled('button')(
    () => ({
        zIndex: 2,
        cursor: 'pointer',
    }),
    ({ touchDevice }) => {
        if (touchDevice) {
            return {
                display: 'none',
            };
        }
        return {};
    },
);

const StyledSlide = styled('div')(() => ({
    marginRight: columnGutter.small,
}));

const StyledSlideBig = styled(StyledSlide)({
    flex: `0 0 ${remCalc(100)}`,

    // be careful !! because of ReactResizeSensor being triggered only when parent's width changes,
    // we need to have a different width between:
    // medium breakpoint = 525px (=> teaser in landscape format)
    // xlarge breakpoint = 520px (=> teaser in square format)
    // without that, ReactResizeSensor does not call "onResize" function which updates the picture format
    [mediaQueries.medium]: {
        flex: `0 0 ${remCalc(525)}`,
        marginRight: columnGutter.medium,
    },

    [mediaQueries.xlarge]: {
        flex: `0 0 ${remCalc(520)}`,
    },
});

const StyledSlideDual = styled(StyledSlide)({
    display: 'flex',
    flex: '0 0 auto',

    [mediaQueries.medium]: {
        marginRight: columnGutter.medium,
    },

    [mediaQueries.xlarge]: {
        height: remCalc(520),
        flex: `0 0 ${remCalc(325)}`,
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
});

export { StyledArrowNext, StyledArrowPrev, StyledSlideBig, StyledSlideDual };
